import { Component} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { AnfrageService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { InstitutionDisplayModel, InstitutionDisplayModelFormGroup } from '@/api/model-index';
import { ContactDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';

@Component({
    selector: 'institution-form-process-step',
    templateUrl: './institution-form-process-step.component.html',
    styleUrls: ['./institution-form-process-step.component.scss'],
    standalone: false
})
export class InstitutionFormProcessStepComponent extends AnfrageNavigationFormComponent  {

  public institutionDataForm: InstitutionDisplayModelFormGroup;
  public institutionData: InstitutionDisplayModel;

  public get formGroup(): FormGroup<any> {
    return this.institutionDataForm;
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected sectionService: SectionService,
    protected anfrageService: AnfrageService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected loadingAnimationService: LoadingAnimationService,
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {

      super(sectionService, router, route, portalContextService);

    this.institutionData = this.route.snapshot.data.contactData.institution;
    this.institutionDataForm = InstitutionDisplayModelFormGroup.Instance

    this.institutionDataForm.patchValue(this.institutionData);
  }

  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {

    if (shouldSave && this.institutionDataForm.dirty) {
      this.institutionData = this.institutionDataForm.getRawValue();

      delete this.portalContextService.CurrentAnfrage.contactData;
      this.institutionDataForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }
      
      let subscription = this.anfrageService.apiAnfrageAnfrageIdContactDataInstitutionPatch({ anfrageId: this.anfrage.id, body: this.institutionData })
        .subscribe(() => {
          this.anfrageService.apiAnfrageAnfrageIdContactDataGet({ anfrageId: this.anfrage.id }).subscribe(response => {
            
            if (response) {
              this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
                this.stateService.ValidationErrors = result;
              })

              if (this.portalContextService.CurrentAnfrage) {
                this.portalContextService.CurrentAnfrage.contactData = response
              }

              this.institutionDataForm.patchValue(response);
              this.institutionDataForm.markAsPristine();
            }

          });
        }, (error) => {
          this.institutionDataForm.markAsDirty();
          throw error;
        });
      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.institutionDataForm.markAsPristine();
      this.move(moveDirection);
    }
      
  }
}
